import { JsonProperty, JsonObject } from 'json2typescript';

import { Required, EmptyControl, Nested } from '@hvlng/framework-bff/core';
import { CodeTextModel } from '../../code-text/model/code-text-model';
import { PerIdentificationSubtypeModel } from '../../identification-subtype/model/per-identification-subtype-model';

@JsonObject('KovanHrPerSocialSecuritySubtypeModel')
export class PerSocialSecuritySubtypeModel extends CodeTextModel {
    @Required()
    @JsonProperty('perIdentificationSubtypeId', Number, true)
    perIdentificationSubtypeId: number = null;

    @EmptyControl()
    @JsonProperty('perIdentificationSubtypeCode', String, true)
    perIdentificationSubtypeCode: string = null;

    @Nested()
    @JsonProperty('perIdentificationSubtype', PerIdentificationSubtypeModel, true)
    perIdentificationSubtype: PerIdentificationSubtypeModel = new PerIdentificationSubtypeModel();
}
